import axios from 'axios'
import { store } from '../store'
import { hideLoader, showLoader } from '../store/loader/actions'
import {
  attachCsrfToken,
  clearCsrfToken,
  ensureCsrfToken,
  installCsrfInterceptors,
  isAdminUrl,
  isMutating,
  CSRF_HEADER,
} from './csrf'

let logoutInProgress = false
export const setLogoutInProgress = (value) => { logoutInProgress = value }

// VAPT #6 — some admin writes (metadata/library crud) use the plain `axios.*` client, which bypasses
// this instance's interceptors. Cover the default client too so no admin mutation is missed; the
// header is gated to mutating admin-origin requests, so it is a no-op for reads and other services.
installCsrfInterceptors(axios)

const instance = axios.create()
instance.interceptors.request.use(
  async config => {
    store.dispatch(showLoader())
    config.withCredentials = true
    return attachCsrfToken(config)
  },
  error => Promise.reject(error)
)


export const instanceVideoFile = axios.create()
instanceVideoFile.interceptors.request.use(
  config => {
    store.dispatch(showLoader())
    return config
  },
  err => Promise.reject(err)
)


instance.interceptors.response.use(
  response => {
    store.dispatch(hideLoader())
    return response
  },
  async error => {
    store.dispatch(hideLoader())

    const status = error?.response?.status
    const config = error?.config

    // VAPT #6 — a 403 on a mutating admin request can be a missing/stale CSRF token: refresh once,
    // re-attach, and retry a single time (guarded so it never loops).
    if (
      status === 403 &&
      config &&
      !config.__csrfRetried &&
      isMutating(config.method) &&
      isAdminUrl(config.url)
    ) {
      config.__csrfRetried = true
      const token = await ensureCsrfToken(true)
      if (token) {
        config.headers = config.headers || {}
        config.headers[CSRF_HEADER] = token
        return instance(config)
      }
    }

    if (status === 401 && !logoutInProgress) {
      localStorage.clear()
      clearCsrfToken()
      window.location.href = `${process.env.REACT_APP_AWS_COGNITO}/logout?response_type=code&client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENTID}&redirect_uri=${process.env.REACT_APP_AWS_COGNITO_REDIRECT_URI}`
    }

    return Promise.reject(error)
  }
)

export default instance

